<div class="container-xxl">
  <div class="row text-center justify-content-lg-center ">
      <div class="col-12 col-lg-9">
          <h4>
              Permesso negato! Se il problema persiste contatta Wallnet!
          </h4>
      </div>
  </div>
</div>
